import React from 'react';
import { useTranslation } from 'react-i18next';
import { Car } from 'lucide-react';
import './Header.css';

export const Header = () => {
  const { t } = useTranslation();

  return (
    <header className="app-header" data-testid="app-header">
      <div className="app-header__inner">
        <div className="app-header__logo-icon" data-testid="header-logo-icon">
          <Car size={32} strokeWidth={2.2} />
        </div>
        <h1 className="app-header__title" data-testid="header-app-name">
          {t('home.appName')}
        </h1>
      </div>
    </header>
  );
};
